// extracted by mini-css-extract-plugin
module.exports = {"tagWrapper":"Tag_tagWrapper__NWSka","selectedTagWrapper":"Tag_selectedTagWrapper__vhFD0"};